import { useEffect, useState } from "react";
import Chart from "../../../../components/Chart";
import CustomLoader from "../../../../components/CustomLoader";
import Metrics from "../../../../components/Metrics";
import { getTotalGross } from "../../utils/utils";

function AnalyticsContainer({ receipts, sales, isLoading = false, ...props }) {
  const [totalPurchases, setTotalPurchases] = useState("");
  const [totalSales, setTotalSales] = useState("");
  const [netProfit, setNetProfit] = useState("");

  useEffect(() => {
    const totalPurchase = getTotalGross(receipts);
    const totalSale = getTotalGross(sales);
    setTotalPurchases(totalPurchase);
    setTotalSales(totalSale);

    const calculatedNetProfit = totalSale - totalPurchase;

    setNetProfit(calculatedNetProfit);
  }, [receipts, sales]);

  const objects = [
    {
      label: "Total Sales",
      value: totalSales,
      icon: "bi bi-cash-stack",
      color: "#1B5E20",
    },
    {
      label: "Total Purchases",
      value: totalPurchases,
      icon: "bi bi-bag-dash",
      color: "#E63946",
    },
    {
      label: "Net Profit",
      value: netProfit,
      icon: "bi bi-currency-exchange",
      color: "#01449C",
    },
  ];
  return (
    <>
      {isLoading ? (
        <CustomLoader />
      ) : (
        <div className="d-flex flex-column gap-4">
          {/* Metrics Section */}
          <div>
            <Metrics objects={objects} {...props} />
          </div>

          {/* Charts Section */}
          <div
            className="bg-white rounded-3 shadow-sm"
            style={{
              padding: "1.5rem",
              border: "1px solid #e9ecef",
            }}
          >
            <Chart receipts={receipts} sales={sales} {...props} />
          </div>
        </div>
      )}
    </>
  );
}

export default AnalyticsContainer;
